import { render, staticRenderFns } from "./RegisterQTDog.vue?vue&type=template&id=20aaca90"
import script from "./RegisterQTDog.vue?vue&type=script&lang=ts"
export * from "./RegisterQTDog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports